export enum VirusName {
  SARS_COV_2 = 'SARS-CoV-2',
}
